export default __webpack_public_path__ + "static/media/number-2.8e6b16dc.svg";